import { useEffect } from 'react'

import { useGlobalContext } from '../../../../context/ContextGlobal'
import { TryCatch } from '../../../../utils/general'
import { addSubDocument, getSubDocuments, getSubDocumentsWithQuerys } from '../../../../firebase/firestore'
// import { getAddressByCep } from '../../../../utils/consultingCEP'
import { estados } from '../../../../utils/stateCity'
import { getAddressByCep } from '../../../../utils/consultingCEP'

export const useClientFormEvents = (values, setValues, options, clientId = null) => {
  const { user, setLoading, setAlerts, setInfosContext, infosContext, formContext, setFormContext } = useGlobalContext()

  const getInfos = async () => {
    const getAdmins = await getSubDocuments('clientes', user.client.id, 'users')
    // console.log(getcitys)

    setInfosContext((prev) => ({ ...prev, myAdmins: getAdmins }))
  }

  const cidades = estados.flatMap((estado) =>
    estado.cidades.map((cidade) => ({
      label: `${cidade}, ${estado.sigla}`,
      value: `${cidade}, ${estado.sigla}`,
    })),
  )

  const myAdmins = (infosContext?.myAdmins || []).map((admin) => {
    return { label: `${admin.name || admin.nome} - ${admin.cargo}`, value: admin.id }
  })

  // const updateUf = async (ufByCity) => {
  //   const expectedUf = await ufByCity

  //   setFormContext((prev) => ({ ...prev, uf: expectedUf?.slice(-2) }))
  // }

  useEffect(() => {
    const fetchAddress = async () => {
      const getAllAdressInfo = await getAddressByCep(values.cep || '')

      setFormContext((prev) => ({
        ...prev,
        endereco: getAllAdressInfo.logradouro,
        city: `${getAllAdressInfo.localidade}, ${getAllAdressInfo.uf}`,
      }))
      // updateUf(formContext.city)
    }

    fetchAddress()
  }, [formContext.cep])

  const addCity = async () => {
    // const type = formContext?.newCity || false
    const type = formContext?.selectCityRestrictions || false
    // console.log(type)
    let newCity
    // adicionar um evento
    if (type) {
      if (!user.user.permissions.city_add) {
        return setAlerts((prev) => [
          ...prev,
          {
            type: 'error',
            title: 'Permissão Negada',
            msg: 'Você não possui permissão para realizar essa ação.',
          },
        ])
      }
      // const cep = formContext?.inputCEP || null
      // if (!cep) {
      //   return setAlerts((prev) => [
      //     ...prev,
      //     { type: 'error', title: 'Cep Obrigatório', msg: 'Digite um cep válido para continuar' },
      //   ])
      // }

      // const infosCep = await getAddressByCep(cep)

      // if (infosCep?.error) {
      //   return setAlerts((prev) => [...prev, { type: 'error', title: 'Erro ao buscar cep', msg: infosCep?.error }])
      // }

      const city = type.split(',')[0].trim()
      const uf = type.slice(-2)

      const query = [
        { field: 'city', operator: '==', value: city },
        { field: 'uf', operator: '==', value: uf },
      ]
      const exist = await getSubDocumentsWithQuerys('clientes', user.client.id, 'citys', query)

      newCity = { city, uf }
      // console.log(newCity)

      if (Array.isArray(exist) && exist.length === 0) {
        await addSubDocument('clientes', user.client.id, 'citys', newCity)
      }
    } else {
      const selectCityRestrictions = formContext?.selectCityRestrictions || null

      const city = infosContext?.citys?.find((values) => values.id === selectCityRestrictions) || null

      if (!selectCityRestrictions && !city) {
        return setAlerts((prev) => [
          ...prev,
          { type: 'error', title: 'Selecione uma cidade', msg: 'Para continuar, selecione uma cidade permitida...' },
        ])
      }

      newCity = { city: city.city, uf: city.uf }
    }

    await FetchGetInfos()
    setFormContext((prev) => {
      const cityRestrictions = (prev?.cityRestrictions || []).filter((values) => {
        // Filtra as cidades que não possuem a mesma cidade e UF
        return values.city !== newCity.city || values.uf !== newCity.uf
      })

      // Retorna o novo contexto com a cidade adicionada
      return { ...prev, cityRestrictions: [newCity, ...cityRestrictions] }
    })
    return setAlerts((prev) => [
      ...prev,
      {
        type: 'success',
        title: 'Cidade Adicionada',
        msg: `A Cidade "${newCity.city}" foi adicionada com sucesso na sua base de dados.`,
      },
    ])
  }

  const deleteCity = async (values) => {
    const city = values.city
    const uf = values.uf

    setFormContext((prev) => {
      const cityRestrictions = (prev?.cityRestrictions || []).filter((values) => {
        // Filtra as cidades que não possuem a mesma cidade e UF
        return values.city !== city || values.uf !== uf
      })

      // Retorna o novo contexto com a cidade adicionada
      return { ...prev, cityRestrictions: [...cityRestrictions] }
    })
  }

  const delVestments = async (vestiment) => {
    let submitVestmentsCurrent = values?.submitVestments || []

    if (submitVestmentsCurrent) {
      submitVestmentsCurrent = submitVestmentsCurrent.filter((vests) => {
        return vests !== vestiment
      })
      await setValues((prev) => ({
        ...prev,
        submitVestments: submitVestmentsCurrent,
      }))
    }
  }

  const addAdmins = async () => {
    // const type = formContext?.newCity || false
    const idAdmin = formContext?.selectAllowedAdmins || false
    const adminsList = infosContext?.myAdmins || []
    console.log(idAdmin)

    if (idAdmin) {
      const admin = adminsList.find((adm) => adm.id === idAdmin)

      const newAdmins = {
        name: admin.nome || admin.name,
        cpf: admin.cpf,
        position: admin.cargo,
        id: idAdmin,
      }

      setFormContext((prev) => {
        const allowedAdmins = (prev?.allowedAdmins || []).filter((values) => {
          // Filtra os administradores que não tem o id, para não duplicar
          return newAdmins.id !== values.id
        })

        // Retorna o novo contexto com a cidade adicionada
        return { ...prev, allowedAdmins: [newAdmins, ...allowedAdmins] }
      })
      await FetchGetInfos()

      return setAlerts((prev) => [
        ...prev,
        {
          type: 'success',
          title: 'Permissão de Checkin Checkout Adicionada',
          msg: `Agora o usuário "${newAdmins.name}" pode realizar checkin e chekout desse evento.`,
        },
      ])
    } else {
      return setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Nenhum administrador selecionado',
          msg: `Para adicionar Selecione um administrador e depois clique em Adicionar.`,
        },
      ])
    }
  }

  const deleteAdmin = async (values) => {
    const idAdmin = values.id

    setFormContext((prev) => {
      const allowedAdmins = (prev?.allowedAdmins || []).filter((values) => {
        // Filtra as cidades que não possuem a mesma cidade e UF
        return values.id !== idAdmin
      })
      // Retorna o novo contexto com a cidade adicionada
      return { ...prev, allowedAdmins }
    })
  }

  const HandleDeleteVestments = async (vestments) => {
    await TryCatch(
      () => {
        delVestments(vestments)
      },
      setLoading,
      setAlerts,
    )
  }

  const HandleDeleteCity = async (values) => {
    await TryCatch(
      async () => {
        await deleteCity(values)
      },
      setLoading,
      setAlerts,
    )
  }

  const HandleAddCity = async () => {
    await TryCatch(addCity, setLoading, setAlerts)
  }

  const HandleAddAdmin = async () => {
    await TryCatch(addAdmins, setLoading, setAlerts)
  }

  const HandleDeleteAdmin = async (values) => {
    await TryCatch(
      async () => {
        await deleteAdmin(values)
      },
      setLoading,
      setAlerts,
    )
  }

  const FetchGetInfos = async () => {
    await TryCatch(getInfos, setLoading, setAlerts)
  }

  useEffect(() => {
    FetchGetInfos()
  }, [])

  return {
    infosContext,
    cidades,
    HandleDeleteVestments,
    HandleAddCity,
    HandleDeleteCity,
    HandleAddAdmin,
    HandleDeleteAdmin,
    myAdmins,
  }
}
